import React from 'react';
import ProfileData from './Profile';

const Profile = (props) => (
  <ProfileData  {...props} />
);

export default Profile;



// WEBPACK FOOTER //
// ./src/components/Profile/NavBarProfile/index.js